import { FC, ReactNode } from "react";
import { Button, message, Flex, Card, Modal } from "antd";
import { useMutation } from "@tanstack/react-query";
import { queryKeys } from "../../services/react-query/queryKeys";
import queryClient from "../../services/react-query/queryClient";
import { useIntl } from "react-intl";

interface DeleteModalProps<T, U = undefined> {
  visible: boolean;
  onClose: () => void;
  onDelete: (data: T, param2?: U) => Promise<void>; // Make param2 optional
  data: any | null;
  confirmationHeader: string;
  confirmationText: string;
  successMessage: string;
  queryKey?: string;
  optionalDiv?: ReactNode | null;
  optionalParam2?: any | null; // Make optionalParam2 optional
  queryKeyList?: any | null;
  afterDelete?: () => void;
}

const DeleteModal: FC<DeleteModalProps<any>> = ({
  visible,
  onClose,
  onDelete,
  data,
  optionalParam2,
  confirmationHeader,
  confirmationText,
  optionalDiv,
  successMessage,
  afterDelete,
  queryKey,
}) => {
  const { mutate: deleteMutation, isLoading } = useMutation(
    () => onDelete(data, optionalParam2),
    {
      onSuccess: () => {
        if (afterDelete) {
          afterDelete();
        }
        if (queryKey) {
          queryClient.invalidateQueries([queryKey]);
        } else {
          queryClient.invalidateQueries([queryKeys.listClient]);
        }

        message.success(successMessage);
        onClose();
      },
      onError: () => {
        message.error("حاول مرة اخرى");
      },
    }
  );

  const handleDelete = async () => {
    if (data) {
      deleteMutation(data);
    }
  };
  const intl = useIntl();
  return (
    <Modal
      centered
      open={visible}
      onOk={handleDelete}
      onCancel={onClose}
      okButtonProps={{ disabled: true }}
      cancelButtonProps={{ disabled: true }}
      footer={[]}
      width={550}
      wrapClassName="delete-modal-wrapper"
    >
      <div className="m-6 border-0 mb-0">
        <div className="text-color-primary text-base font-semibold leading-7 text-center">
          {confirmationHeader}
        </div>
        <div className="my-4 text-color-gray text-sm font-normal leading-7 text-center">
          {confirmationText}
        </div>

        <div>{optionalDiv}</div>

        <Flex gap="middle" align="center" justify="center">
          <Button
            type="primary"
            danger
            onClick={handleDelete}
            loading={isLoading}
            className="bg-color-primary h-full text-white text-lg rounded-md px-2 w-full"
            htmlType="submit"
          >
            {intl.formatMessage({ id: "delete_confirmation_yes_button" })}
          </Button>
          <Button
            type="primary"
            onClick={onClose}
            block
            className="btn-primary-light"
            htmlType="button"
          >
            {intl.formatMessage({ id: "cancel_button" })}
          </Button>
        </Flex>
      </div>
    </Modal>
  );
};

export default DeleteModal;
